import React, {Component} from 'react';
import Slider from "react-slick";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { TalksService } from '../../services/talks';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './commerce.css';
import Logo from "./logo.png";
import { Checkout } from '../../components';

export default class ViewCommerce extends Component {
  constructor(props) {
    super(props);
    this.state = {
      "render_checkout": false,
      user: 'Jenny Wilson',
      categories: [
        "Série Universitária",
        "Ciências Humanas",
        "Comunicação e Artes",
        "Design, Arquitetura e Moda",
        "Gastronomia e Nutrição",
        "Gestão e Negócios",
        "Segurança e Saúde no Trabalho",
        "Saúde, Bem Estar e Beleza",
        "Tecnologia da Informação",
        "Turismo e Hotelaria"
      ],
      topAuthors: [
        {
          "name": "Rita Lobo",
          "thumb": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQI9eEjyVxdjNEZikjQ4IsEOdvBvTRkIpe1qw&s",
        },
        {
          "name": "Michelle Marine",
          "thumb": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDdGdVNwXrip_bSmXfNvwIzcO4WechfNIUHA&s",
        },
        {
          "name": "Raul Lody",
          "thumb": "https://editora.cepe.com.br/uploads/2019/03/22/5c94d59af2cf2.raul-lody..default.jpg",
        },
        {
          "name": "Flavio Campos",
          "thumb": "https://cdn.adscientificindex.com/pictures/ac/4326520.jpg",
        }
      ],
      popularBooks: [
        {
          title: 'Bases de Confeitaria',
          author: 'Michelle Marine',
          price: 70,
          oldPrice: 100,
          cover: "https://storage-aws-production.publica.la/bookwire-brazil/issues/2025/04/yQQpZlYxYiqWszaY/f1ea72d7-dbb1-4a75-8930-fc7831b646fd_cover.jpg"
        },
        {
          title: 'A robótica para uso educacional',
          author: 'Flavio Rodrigues Campos',
          price: 79,
          oldPrice: 120,
          cover: "https://m.media-amazon.com/images/I/81d0XniXc7L._AC_UF1000,1000_QL80_.jpg"
        },
        {
          title: 'Águas de Comer',
          author: 'Raul Lody',
          price: 69,
          oldPrice: 99,
          cover: "https://www.editorasenacsp.com.br/o/commerce-media/accounts/-1/images/95473525?download=false"
        }
      ],
    };
  }

  render() {
    var _this = this;
    const { user, categories, topAuthors, popularBooks } = this.state;

    return (
      <div className="app-container">
        <img className="rdp-app-view-commerce-logo" src={Logo} style={{width: "90px"}}/>
        <header>
          {/* <h2>{user}</h2> */}
          <p className="header-title">Explore nosso livros e compre já!</p>
          <input type="text" placeholder="Encontre aqui o seu livro" className="search-box" />
        </header>

        <div className="categories">
          {categories.map((cat, index) => (
            <button key={index} className="category-btn">{cat}</button>
          ))}
        </div>

        <div className="section">
          <div className="section-header">
            <h3>Top Autores</h3>
            <span className="see-all">Ver Todos</span>
          </div>
          <div className="authors">
            {topAuthors.map((author, index) => (
              <div key={index} className="author">
                <div className="author-circle" style={{backgroundImage: `url(${author.thumb})`}}></div>
                <div className="author-name">{author.name}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="section">
          <div className="section-header">
            <h3>Mais Populares</h3>
            <span className="see-all">Ver Todos</span>
          </div>
          
          <div className="books">
            {popularBooks.map((book, index) => (
              <div key={index} className="book-card" onClick={() => _this.setState({"render_checkout": true})}>
                <div className="book-cover" style={{backgroundImage: `url(${book.cover})`}}></div>
                <div className="book-info">
                  <p className="book-title">{book.title} <br /> <span className="book-author">{book.author}</span></p>
                  <p className="book-price">R${book.price} <span className="old-price">R${book.oldPrice}</span></p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {this.state.render_checkout &&
          <div className="rdp-app-view-commerce-modal">
            <div className="rdp-app-view-commerce-overlay" onClick={() => this.setState({"render_checkout": false})}></div>
            <div className="rdp-app-view-commerce-content">
              <Checkout/>
            </div>
          </div>
        }
      </div>
    );
  }
}